// "Drukuj plakat" (pages/posters.ejs): opens the poster original in
// a new window and prints it once the image has loaded - a fixed delay printed
// a blank page on slow connections. Without a window (pop-up blocked) the
// poster itself opens, so it can still be printed from the browser.
function printPoster(src: string, title: string): void {
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
        window.location.href = src;
        return;
    }

    const doc = printWindow.document;
    doc.title = title;
    doc.body.style.cssText = 'margin:0;display:flex;align-items:center;justify-content:center';
    const image = doc.createElement('img');
    image.alt = title;
    image.style.cssText = 'max-width:100%;max-height:100vh';

    const print = () => {
        printWindow.focus();
        printWindow.print();
    };
    printWindow.addEventListener('afterprint', () => printWindow.close());
    image.addEventListener('load', print, { once: true });
    image.src = src;
    doc.body.append(image);
}

document.addEventListener('click', (event) => {
    const button = (event.target as Element | null)?.closest<HTMLElement>('[data-print-src]');
    if (!button) return;
    event.preventDefault();
    printPoster(button.dataset.printSrc!, button.dataset.printTitle ?? document.title);
});
